import { render, staticRenderFns } from "./InsightCard.vue?vue&type=template&id=3ee88e70&scoped=true&"
import script from "./InsightCard.vue?vue&type=script&lang=js&"
export * from "./InsightCard.vue?vue&type=script&lang=js&"
import style0 from "./InsightCard.vue?vue&type=style&index=0&id=3ee88e70&prod&scoped=true&lang=css&"
import style1 from "./InsightCard.vue?vue&type=style&index=1&id=3ee88e70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee88e70",
  null
  
)

export default component.exports